import { render, staticRenderFns } from "./diagram-view-area-browser.component.vue?vue&type=template&id=3252ea16"
import script from "./diagram-view-area-browser.component.ts?vue&type=script&lang=ts&external"
export * from "./diagram-view-area-browser.component.ts?vue&type=script&lang=ts&external"
import style0 from "./diagram-view-area-browser.component.vue?vue&type=style&index=0&id=3252ea16&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3252ea16')) {
      api.createRecord('3252ea16', component.options)
    } else {
      api.reload('3252ea16', component.options)
    }
    module.hot.accept("./diagram-view-area-browser.component.vue?vue&type=template&id=3252ea16", function () {
      api.rerender('3252ea16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/diagram-view/diagram-view-area-browser/diagram-view-area-browser.component.vue"
export default component.exports